import {Observable} from 'rxjs';
import {Parameter} from '../common/parameter';
import { Binary } from '@angular/compiler';

export interface AssetSubTypeParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface AssetSubType {
    id?: any;
    tenantId: any;
    branchId: any;
    name:string;
    assetType: any;
    createdby:string;
    createddate:any;
    updatedby:string;
    updateddate:any;
    assetTypeMst?: any;
    parameters?: AssetSubTypeParameter[];
    links?: any;
}

export abstract class AssetSubTypeData {
   
    abstract list(url: string): Observable<AssetSubType[]>;
    abstract create(url: string, data: AssetSubType): Observable<AssetSubType[]>;
    abstract update(url: string, data: AssetSubType): Observable<AssetSubType>;
    abstract delete(url: string): Observable<any>;
}